import React from 'react';
import TherapistDetail from './TherapistDetail';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	isOpen: boolean;
	onClose: () => void;
	userId: string;
}

const TherapistDetailModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='base.myTherapistProfile' size={Size.LG}>
			<TherapistDetail userId={props.userId} />
		</BaseModal>
	);
};

export default TherapistDetailModal;
